<template>
    <td class="OTborder-right p25" colspan="">
        <span class="OTicon-extend-info" v-on:click="showExtraInfo(showExtra)" v-bind:class="{ 'OTicon-close-info': showExtra }"></span>
        <ul class="list-unstyled OTtableCompInfo">
            <li class="OTtableCompName" >
                <a v-if="component.adminUrl" :href="component.adminUrl" target="_blank">
                    {{ component.componentName }}
                </a>
                <span v-else>
                    {{ component.componentName }}
                </span>
            </li>
            <li class="OTtableCompHost"><span class="OTsimplelabel">Host:</span>{{ component.host }}</li>
            <li :class="{OTtableCompStatusRunning: isRunning, OTtableCompStatusError: isNotRunning}" class="OTtableCompStatus OTtableCompStatusRunning" v-show="showExtra"><span class="OTsimplelabel">Status:</span>{{ componentStatus }}</li>
            <li class="OTtableCompLastConnect" v-show="showExtra && isNotRunning"><span class="OTsimplelabel">Last Contact: {{ lastContact }}</span></li>
        </ul>
     </td>
</template>

<script>

import componentTablesMixin from '../../mixins/componentsTable.js';

export default {
    mixins: [componentTablesMixin],
    props: ['componentId'],
    data() {
      return {
        showExtra: false
      }
    },

    computed: {
        component() {
            return this.$store.state.components.components[this.componentId];
        },

        lastContact() {
            var component = this.component;
            var seconds = component['lastContact'];



            if (!seconds) {
                return '00h:00m:00s';
            } else {
                var hours = Math.floor(seconds / 3600);
                var minutes = Math.floor((seconds - (hours * 3600)) / 60);
                var seconds = seconds - (hours * 3600) - (minutes * 60);

                if (hours < 10)     { hours = "0" + hours; }
                if (minutes < 10)   { minutes = "0" + minutes;}
                if (seconds < 10)   { seconds = "0" + seconds;}

                return hours + "h:" + minutes + "m:" + seconds + "s";
            }
        },

        componentStatus() {

            var component = this.component;

            if (!component['status']) {
                return 'Running';
            } else {
                if (component['status'] === 'running') {
                    return 'Running'
                } else if (component['status'] === 'not running') {
                    return 'Not Running'
                }
            }
        },

        isRunning() {
            if (this.componentStatus === 'Running') {
                return true;
            } else {
                return false;
            }
        },

        isNotRunning() {
            return !this.isRunning;
        }
    },

    methods: {
       showExtraInfo: function(showExtraorNot) {
            if ( showExtraorNot ){
                this.showExtra = false
            }
            else{
                this.showExtra =  true
            }
        }
    },

    watch: {
        isRunning() {
            if (this.isNotRunning === true) {
                this.showExtra = true;
            }
        }
    },

    mounted() {
        this.$parent.$on('show-extra-info', () => {
            if (this.showExtra === true) {
                this.showExtra = false;
            } else {
                this.showExtra = true;
            }
        });

        if (this.isNotRunning) {
            this.showExtra = true;
        }
    }
}
</script>
